export function filenameFromDisposition(header, fallback) {
  const utfMatch = /filename\*=UTF-8''([^;]+)/i.exec(header || '');
  if (utfMatch) return decodeURIComponent(utfMatch[1]);

  const match = /filename="?([^";]+)"?/i.exec(header || '');
  return match ? match[1] : fallback;
}

export async function downloadBlobResponse(response, fallbackFilename) {
  const status = response.status;
  const contentType = response.headers['content-type'] || '';
  const looksLikeFile = /openxmlformats|spreadsheet|sheet|excel|octet-stream|xml/i.test(contentType);

  if (status >= 400 || !looksLikeFile) {
    let detail = `Ошибка выгрузки (HTTP ${status})`;
    try {
      const text =
        response.data && typeof response.data.text === 'function'
          ? await response.data.text()
          : String(response.data ?? '');
      try {
        const parsed = JSON.parse(text);
        detail = parsed.detail || parsed.message || text.slice(0, 500) || detail;
      } catch {
        detail = text.slice(0, 500) || detail;
      }
    } catch {
      // ignore parse errors
    }
    throw new Error(detail);
  }

  const blob = new Blob([response.data], { type: contentType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filenameFromDisposition(response.headers['content-disposition'], fallbackFilename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
